import Home from "@/views/PC/Home.vue";

import Play from "@/views/H5/Play.vue"; //播放页不懒加载
import ScorePlay from "@/views/H5/ScorePlay.vue"; //评分播放页不懒加载
export const pcRoutes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: "/learn",
    children: [
      {
        path: "/collection",
        name: "Collection",
        meta: { title: "我的收藏" },
        component: () =>
          import(
            /* webpackChunkName: "collection" */ "../views/PC/Collection.vue"
          ),
      },
      {
        path: "/learn",
        name: "Learn",
        meta: { title: "我的课程" },
        component: () =>
          import(/* webpackChunkName: "learn" */ "../views/PC/Learn.vue"),
      },
      {
        path: "/myPro",
        name: "MyPro",
        meta: { title: "我的项目" },
        component: () =>
          import(/* webpackChunkName: "mypro" */ "../views/PC/MyPro.vue"),
      },
      {
        path: "/message",
        name: "Message",
        meta: { title: "消息中心" },
        component: () =>
          import(
            /* webpackChunkName: "message" */ "../views/PC/MessageList.vue"
          ),
      },
      {
        path: "/mycertificate",
        name: "MyCertificate",
        meta: { title: "我的证书" },
        component: () =>
          import(
            /* webpackChunkName: "mycertificate" */ "../views/PC/MyCertificate.vue"
          ),
      },
      {
        path: "/account",
        name: "Account",
        meta: { title: "账号设置" },
        component: () =>
          import(/* webpackChunkName: "account" */ "../views/PC/Account.vue"),
      },
      {
        path: "/renzheng",
        name: "RenZheng",
        meta: { title: "账号认证" },
        component: () =>
          import(/* webpackChunkName: "renzheng" */ "../views/PC/RenZheng.vue"),
      },
      {
        path: "/notforce",
        name: "NotForce",
        meta: { title: "认证选填" },
        component: () =>
          import(/* webpackChunkName: "notforce" */ "../views/PC/NotForce.vue"),
      },
    ],
  },
  // 兼容pc端没有my页面
  {
    path: "/my",
    name: "My",
    redirect: (to) => {
      return {
        name: "Learn",
        query: to.query,
      };
    },
  },
  // 找回密码
  {
    path: "/retrieve",
    name: "Retrieve",
    meta: { title: "个人中心" },
    component: () =>
      import(/* webpackChunkName: "message" */ "../views/PC/Retrieve.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: { title: "个人中心" },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/PC/Login.vue"),
  },
  {
    path: "/bindphone",
    name: "BindPhone",
    meta: { title: "个人中心" },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/PC/Bind.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    meta: { title: "个人中心" },
    component: () => import("../views/PC/Privacy.vue"),
  },
  // {
  //   path: "/play",
  //   name: "Play",
  //   component: () =>
  //     import(/* webpackChunkName: "play" */ "../views/PC/Play.vue"),
  // },
  {
    path: "/play",
    name: "Play",
    component: () =>
      import(/* webpackChunkName: "play" */ "../views/PC/NewPlay.vue"),
  },
  // 20260104新增需求 视频评分
  {
    path: "/scoreplay",
    name: "ScorePlay",
    component: () =>
      import(/* webpackChunkName: "play" */ "../views/PC/ScorePlay.vue"),
  },
  {
    path: "/fileView",
    name: "FileView",
    meta: { title: "文件预览" },
    component: () =>
      import(/* webpackChunkName: "fileview" */ "../views/PC/FileView.vue"),
  },

  {
    path: "/exammanage",
    name: "ExamManage", //考试
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/PC/ExamManage.vue"),
  },
  {
    path: "/exercise",
    name: "Exercise",
    meta: { title: "练习" },
    component: () =>
      import(/* webpackChunkName: "exercise" */ "../views/PC/XitiDetail.vue"),
  },

  {
    path: "/livequestion",
    name: "LiveQuestion",
    component: () => import("../views/PC/LiveQuestion.vue"),
    meta: {
      title: "调研问卷",
    },
  },

  {
    path: "/newquestion",
    name: "NewQuestion",
    component: () => import("../views/PC/NewQuestion.vue"),
    meta: {
      title: "问卷",
    },
  },
  {
    path: "/specialTraining",
    name: "SpecialTraining",
    component: () =>
      import(
        /* webpackChunkName: "specialtraining" */ "../views/PC/SpecialTraining.vue"
      ),
  },
  {
    path: "/special",
    name: "Special",
    component: () => import("../views/PC/Special.vue"),
    children: [
      {
        path: "/special/generalCurriculum",
        name: "GeneralCurriculum",
        component: () =>
          import(
            /* webpackChunkName: "message" */ "../views/PC/GeneralCurriculum.vue"
          ),
      },
      {
        path: "/special/seriesList",
        name: "SeriesList",
        component: () =>
          import(
            /* webpackChunkName: "message" */ "../views/PC/SeriesList.vue"
          ),
      },
      {
        path: "/special/seriesCourses",
        name: "SeriesCourses",
        component: () =>
          import(
            /* webpackChunkName: "message" */ "../views/PC/SeriesCourses.vue"
          ),
      },
      {
        path: "/special/extendedLearning",
        name: "ExtendedLearning",
        meta: { title: "拓展学习" },
        component: () =>
          import(
            /* webpackChunkName: "message" */ "../views/PC/ExtendedLearning.vue"
          ),
      },
      {
        path: "/special/literature",
        name: "Literature",
        meta: { title: "补充资料" },
        component: () =>
          import(
            /* webpackChunkName: "message" */ "../views/PC/Literature.vue"
          ),
      },
      {
        path: "/special/xitiDetail",
        name: "XitiDetail",
        component: () =>
          import(
            /* webpackChunkName: "message" */ "../views/PC/XitiDetail.vue"
          ),
      },
      {
        path: "/newpilotplay",
        name: "NewPilotPlay", // 基地试点播放页
        meta: { title: "详情" },
        component: () => import("../views/PC/NewPilotPlay.vue"),
      },
      {
        path: "/newpilotplay2",
        name: "NewPilotPlay2", // 基地试点播放页
        meta: { title: "详情" },
        component: () => import("../views/PC/NewPilotPlay2.vue"),
      },
      {
        path: "/pilotProject",
        name: "PilotProject", //基地试点专项培训
        component: () => import("../views/PC/PilotProject.vue"),
      },
    ],
  },
  {
    path: "/courseknowledgepoints",
    name: "CourseKnowledgePoints",
    meta: { title: "ai课程知识点页面" },
    component: () =>
      import(
        /* webpackChunkName: "message" */ "../views/PC/CourseKnowledgePoints.vue"
      ),
  },
  {
    path: "/intelligencePlay",
    name: "IntelligencePlay",
    meta: { title: "ai课程播放页" },
    component: () =>
      import(
        /* webpackChunkName: "message" */ "../views/PC/IntelligencePlay.vue"
      ),
  },
  {
    path: "/patienteducationdetail",
    name: "PatientEducationDetail",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../views/PC/PatientEducationDetail.vue"
      ),
  },
  {
    path: "/assistedconsultationhome",
    name: "AssistedConsultationHome", //AI辅助咨询首页
    meta: { title: "" },
    component: () => import("../views/PC/ai/AssistedConsultationHome.vue"),
  },
  {
    path: "/assistedconsultation",
    name: "AssistedConsultation", //AI辅助咨询
    meta: { title: "AI问诊助手" },
    component: () => import("../views/PC/ai/AssistedConsultation.vue"),
  },
  {
    path: "/assistedconsultationresult",
    name: "AssistedConsultationResult", //AI辅助咨询结果
    meta: { title: "" },
    component: () => import("../views/PC/ai/AssistedConsultationResult.vue"),
  },
  {
    path: "/emailView",
    name: "EmailView", //邮件备份页（收件人复制链接到浏览器打开，内容与邮件一致）
    meta: { title: "邮件内容" },
    component: () => import("../views/EmailView.vue"),
  },
  {
    path: "/emailSend",
    name: "EmailSend", //发送邮件
    meta: { title: "发送邮件" },
    component: () => import("../views/PC/EmailSend.vue"),
  },
  {
    path: "/emailFeedback",
    name: "EmailFeedback", //邮件反馈页（收件人点击接受/拒绝后跳转）
    meta: { title: "反馈结果" },
    component: () => import("../views/EmailFeedback.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "404Error",
    meta: { title: "404" },
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/404View.vue"),
  },
];

export const h5Routes = [
  {
    path: "/",
    redirect: "/my",
  },
  {
    path: "/my",
    name: "My",
    meta: { title: "个人中心" },
    component: () => import(/* webpackChunkName: "my" */ "../views/H5/My.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: { title: "登录" },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/H5/Login.vue"),
  },
  {
    path: "/bindphone",
    name: "BindPhone",
    meta: { title: "绑定手机" },
    component: () =>
      import(/* webpackChunkName: "bindphone" */ "../views/H5/BindPhone.vue"),
  },
  {
    path: "/mhlpbindphone",
    name: "MhlpBindPhone",
    meta: { title: "国家基层儿科医护人员培训系统" }, //儿科绑定手机
    component: () =>
      import(
        /* webpackChunkName: "mhlpbindphone" */ "../views/H5/mhlp/MhlpBindPhone.vue"
      ),
  },
  {
    path: "/learn",
    name: "Learn",
    meta: { title: "我的课程" },
    component: () =>
      import(/* webpackChunkName: "learn" */ "../views/H5/Learn.vue"),
  },
  {
    path: "/myPro",
    name: "MyPro",
    meta: { title: "我的项目" },
    component: () => import("../views/H5/MyPro.vue"),
  },
  {
    path: "/mycertificate",
    name: "MyCertificate",
    meta: { title: "我的证书" },
    component: () => import("../views/H5/MyCertificate.vue"),
  },
  {
    path: "/myachieve",
    name: "MyAchieve",
    meta: { title: "我的成就" },
    component: () => import("../views/H5/MyAchieve.vue"),
  },
  {
    path: "/subscribe",
    name: "Subscribe",
    meta: { title: "我的订阅" },
    component: () => import("../views/H5/Subscribe.vue"),
  },
  {
    path: "/collection",
    name: "collection",
    meta: { title: "我的收藏" },
    component: () => import("../views/H5/Collection.vue"),
  },
  {
    path: "/account",
    name: "account",
    meta: { title: "账号设置" },
    component: () => import("../views/H5/Account.vue"),
  },
  {
    path: "/renzheng",
    name: "RenZheng",
    meta: { title: "个人中心" },
    component: () => import("../views/H5/Renzheng.vue"),
  },
  {
    path: "/records",
    name: "records",
    meta: { title: "个人中心" },
    component: () => import("../views/H5/Records.vue"),
  },
  {
    path: "/phone",
    name: "phone",
    meta: { title: "个人中心" },
    component: () => import("../views/H5/Phone.vue"),
  },
  {
    path: "/notforce",
    name: "NotForce",
    meta: { title: "个人中心" },
    component: () => import("../views/H5/Notforce.vue"),
  },
  {
    path: "/renzhengDetail",
    name: "RenZhengDetail",
    meta: { title: "个人中心" },
    component: () => import("../views/H5/RenzhengDetail.vue"),
  },
  {
    path: "/play",
    name: "Play", //公共播放页
    meta: { title: "加载中..." },
    component: Play,
  },
  {
    path: "/scoreplay",
    name: "Scoreplay",
    meta: { title: "加载中..." },
    component: ScorePlay,
  },
  {
    path: "/fileView",
    name: "FileView",
    meta: { title: "文件预览" },
    component: () => import("../views/H5/FileView.vue"),
  },
  {
    path: "/exercise",
    name: "Exercise",
    meta: { title: "练习" },
    component: () => import("../views/H5/Exercise.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    meta: { title: "隐私申明" },
    component: () => import("../views/H5/Privacy.vue"),
  },
  {
    path: "/score/index",
    name: "MyScore",
    component: () => import("../views/H5/score/Index.vue"),
    meta: {
      title: "积分中心",
    },
  },
  {
    path: "/score/memberday",
    name: "MemberDay",
    component: () => import("../views/H5/score/MemberDay.vue"),
    meta: {
      title: "周二学习日",
    },
  },
  {
    path: "/score/rule",
    name: "ScoreRule",
    component: () => import("../views/H5/score/Rule.vue"),
    meta: {
      title: "积分规则",
    },
  },
  {
    path: "/score/detailed",
    name: "ScoreDetailed",
    component: () => import("../views/H5/score/Detailed.vue"),
    meta: {
      title: "积分明细",
    },
  },
  {
    path: "/score/details",
    name: "ScoreDetails",
    component: () => import("../views/H5/score/Details.vue"),
    meta: {
      title: "兑换详情",
    },
  },
  {
    path: "/toshop",
    name: "ToShop", //积分商城中转页
    meta: { title: "加载中..." },
    component: () =>
      import(/* webpackChunkName: "toshop" */ "../views/H5/ToShop.vue"),
  },
  {
    path: "/newquestion",
    name: "NewQuestion",
    component: () => import("../views/H5/NewQuestion.vue"),
    meta: {
      title: "问卷",
    },
  },
  // 会后问卷
  {
    path: "/livequestion",
    name: "LiveQuestion",
    component: () => import("../views/H5/LiveQuestion.vue"),
    meta: {
      title: "调研问卷",
    },
  },

  {
    path: "/newquestion2",
    name: "NewQuestion2",
    component: () => import("../views/H5/NewQuestion2.vue"),
    meta: {
      title: "问卷",
    },
  },
  {
    path: "/exammanage",
    name: "ExamManage", //考试
    meta: { title: "加载中..." },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/H5/ExamManage.vue"),
  },
  // 以下旧的大会
  {
    path: "/meeting",
    name: "Meeting",
    meta: { title: "加载中..." },
    component: () =>
      import(/* webpackChunkName: "meeting" */ "../views/H5/MeetingTwo.vue"),
  },
  {
    path: "/meetingPay",
    name: "MeetingPay",
    meta: { title: "加载中..." },
    component: () =>
      import(/* webpackChunkName: "meeting" */ "../views/H5/MeetingPay.vue"),
  },
  {
    path: "/meetingOrder",
    name: "MeetingOrder",
    meta: { title: "加载中..." },
    component: () =>
      import(/* webpackChunkName: "meeting" */ "../views/H5/MeetingOrder.vue"),
  },
  {
    path: "/meet/index",
    name: "NewMeetindex",
    meta: { title: "加载中..." },
    component: () => import("../views/H5/meet/Index.vue"),
  },
  {
    path: "/meet/pay",
    name: "NewMeetpay",
    component: () => import("../views/H5/meet/Pay.vue"),
    meta: { title: "加载中..." },
  },
  {
    path: "/meet/manypay",
    name: "NewManyMeetpay",
    component: () => import("../views/H5/meet/ManyPay.vue"),
    meta: { title: "报名" },
  },
  {
    path: "/meet/order",
    name: "NewMeetorder",
    meta: { title: "加载中..." },
    component: () => import("../views/H5/meet/Order.vue"),
  },
  {
    path: "/meet/manyorder",
    name: "NewManyMeetorder",
    component: () => import("../views/H5/meet/ManyOrder.vue"),
    meta: { title: "报名" },
  },
  // 通用大会支付页面
  {
    path: "/commonmeetingpay",
    name: "CommonMeetingPay",
    component: () => import("../views/H5/pay/CommonMeetingPay.vue"),
  },
  {
    path: "/specialTraining",
    name: "SpecialTraining", //专项培训
    meta: { title: "" },
    component: () => import("../views/H5/SpecialTraining.vue"),
  },
  {
    path: "/newspecialTraining",
    name: "NewSpecialTraining", //脑肿瘤专项知识点培训
    component: () => import("../views/H5/NewSpecialTraining.vue"),
  },
  // 以下病例
  {
    path: "/caseList",
    name: "CaseList",
    meta: { title: "病例专区", record: "CaseHome" },
    component: () => import("../views/H5/case/CaseHome.vue"),
  },
  {
    path: "/caseHome",
    name: "CaseHome",
    meta: { title: "病例列表", record: "CaseList" },
    component: () => import("../views/H5/case/CaseList.vue"),
  },
  {
    path: "/case",
    name: "Case",
    redirect: "/case/detail",
    component: () => import("../views/H5/case/Index.vue"),
    children: [
      {
        path: "/case/detail",
        name: "CaseDetail",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "detail" */ "../views/H5/case/CaseDetail.vue"
          ),
      },
      {
        path: "/case/exercises",
        name: "CaseExercises",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "exercises" */ "../views/H5/case/CaseExercises.vue"
          ),
      },
      {
        path: "/case/interpret",
        name: "CaseInterpret",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "interpret" */ "../views/H5/case/CaseInterpret.vue"
          ),
      },
      {
        path: "/case/comments",
        name: "CaseComments",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "interpret" */ "../views/H5/case/CaseComments.vue"
          ),
      },
    ],
  },
  // 以下系列课程
  {
    path: "/special/generalCurriculum",
    name: "GeneralCurriculum",
    component: () => import("../views/H5/GeneralCurriculum.vue"),
  },
  {
    path: "/special/seriesList",
    name: "SeriesList", //列表
    meta: { title: "课程" },
    component: () => import("../views/H5/SeriesList.vue"),
  },
  {
    path: "/special/seriesCourses",
    name: "SeriesCourses", //详情
    component: () => import("../views/H5/SeriesCourses.vue"),
  },
  {
    path: "/special/extendedLearning",
    name: "ExtendedLearning", //其他
    meta: { title: "拓展学习" },
    component: () => import("../views/H5/ExtendedLearning.vue"),
  },
  {
    path: "/special/literature",
    name: "Literature", //文件
    meta: { title: "补充资料" },
    component: () => import("../views/H5/Literature.vue"),
  },
  {
    path: "/special/xitiDetail",
    name: "XitiDetail",
    component: () => import("../views/H5/Exercise.vue"),
  },
  {
    path: "/patienteducationdetail",
    name: "PatientEducationDetail", //患教详情
    component: () => import("../views/H5/PatientEducationDetail/Detail.vue"),
  },
  {
    path: "/patienteducationother",
    name: "PatientEducationOther", //患教列表
    component: () => import("../views/H5/PatientEducationDetail/Toother.vue"),
  },
  {
    path: "/intelligencePlay",
    name: "IntelligencePlay", //ai课程播放页
    meta: { title: "ai课程播放页" },
    component: () => import("../views/H5/IntelligencePlay.vue"),
  },
  {
    path: "/courseknowledgepoints",
    name: "CourseKnowledgePoints", // ai课程知识点页面
    meta: { title: "ai课程知识点页面" },
    component: () => import("../views/H5/CourseKnowledgePoints.vue"),
  },
  {
    path: "/pilotplay",
    name: "PilotPlay", // 基地试点播放页
    meta: { title: "详情" },
    component: () => import("../views/H5/PilotPlay.vue"),
  },
  {
    path: "/newpilotplay",
    name: "NewPilotPlay", // 基地试点播放页
    meta: { title: "详情" },
    component: () => import("../views/H5/NewPilotPlay.vue"),
  },
  {
    path: "/newpilotplay2",
    name: "NewPilotPlay2", // 基地试点播放页
    meta: { title: "详情" },
    component: () => import("../views/H5/NewPilotPlay2.vue"),
  },
  {
    path: "/pilotProject",
    name: "PilotProject", //基地试点专项培训
    component: () => import("../views/H5/PilotProject.vue"),
  },
  {
    path: "/assistedconsultationhome",
    name: "AssistedConsultationHome", //AI辅助咨询首页
    meta: { title: "" },
    component: () => import("../views/H5/ai/AssistedConsultationHome.vue"),
  },
  {
    path: "/assistedconsultation",
    name: "AssistedConsultation", //AI辅助咨询
    meta: { title: "" },
    component: () => import("../views/H5/ai/AssistedConsultation.vue"),
  },
  {
    path: "/assistedconsultationresult",
    name: "AssistedConsultationResult", //AI辅助咨询结果
    meta: { title: "" },
    component: () => import("../views/H5/ai/AssistedConsultationResult.vue"),
  },
  {
    path: "/assistedconsultationhome2",
    name: "AssistedConsultationHome2", //AI辅助咨询首页
    meta: { title: "" },
    component: () => import("../views/H5/ai/AssistedConsultationHome2.vue"),
  },
  {
    path: "/assistedconsultationresult2",
    name: "AssistedConsultationResult2", //AI辅助咨询结果
    meta: { title: "" },
    component: () => import("../views/H5/ai/AssistedConsultationResult2.vue"),
  },
  {
    path: "/assistedconsultationhome3",
    name: "AssistedConsultationHome3", //AI辅助咨询首页
    meta: { title: "" },
    component: () => import("../views/H5/ai/AssistedConsultationHome3.vue"),
  },
  {
    path: "/error/502",
    name: "Error502",
    meta: { title: "错误提示" },
    component: () =>
      import(/* webpackChunkName: "error" */ "../views/H5/error/Error502.vue"),
  },
  {
    path: "/emailFeedback",
    name: "EmailFeedback", //邮件反馈页（收件人点击接受/拒绝后跳转）
    meta: { title: "反馈结果" },
    component: () => import("../views/EmailFeedback.vue"),
  },
  {
    path: "/emailView",
    name: "EmailView", //邮件备份页（收件人复制链接到浏览器打开，内容与邮件一致）
    meta: { title: "邮件内容" },
    component: () => import("../views/EmailView.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "404Error",
    meta: { title: "404" },
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/404View.vue"),
  },
];
